var React = require('react');

function IcDrawer (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4","y":"4","width":"6","height":"6","rx":"1","key":0}),React.createElement("rect",{"x":"4","y":"14","width":"6","height":"6","rx":"1","key":1}),React.createElement("rect",{"x":"14","y":"4","width":"6","height":"6","rx":"1","key":2}),React.createElement("rect",{"x":"14","y":"14","width":"6","height":"6","rx":"1","key":3})]);
}

IcDrawer.defaultProps = {"fill":"#currentColor","viewBox":"0 0 24 24"};

module.exports = IcDrawer;

IcDrawer.default = IcDrawer;
